module.exports = __webpack_public_path__ + "ejemploa1.png?ac14baa7a17762c96ee7bb1b52e2cc7e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ejemploa1.png
// module id = 501
// module chunks = 0